/**
 * Formats a 10-digit US phone number string to XXX-XXX-XXXX
 * @param {string} phoneNumber - The phone number string containing only digits
 * @returns {string} - The formatted phone number
 */
export default function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }

  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-digit characters

  if (
    cleanedPhoneNumber.length !== 10 ||
    !/^\d{10}$/.test(cleanedPhoneNumber)
  ) {
    throw new Error('Invalid phone number');
  }
  return cleanedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}
